import { gql } from '@apollo/client';
import { FILE } from '../fragments';

export const GET_FILE = gql`
  query GetFILE($id: ID!) {
    file(where: { id: $id }) {
      ...file
    }
  }
  ${FILE}
`;
